<template>
  <div>
    <b-row align-v="center" class="d-flex align-items-center">
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $tc("alarm.title", 1) }}</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="alarmFilter"
          :options="alarmOptions"
          class="w-100"
          multiple
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:alarmFilter', val)"
          append-to-body
          :calculate-position="withPopper"
          data-cy="alarm-filter"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $tc("types_alarms.title", 2) }}</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="typeAlarmFilter"
          :options="typeAlarmOptions"
          class="w-100"
          multiple
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:typeAlarmFilter', val)"
          append-to-body
          :calculate-position="withPopper"
          data-cy="type-alarm-filter"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $tc("region.title", 2) }}</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="regionFilter"
          :options="regionOptions"
          class="w-100"
          multiple
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:regionFilter', val)"
          append-to-body
          :calculate-position="withPopper"
          data-cy="region-filter"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $tc("municipality.title", 2) }}</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="municipalityFilter"
          :options="municipalityOptions"
          class="w-100"
          multiple
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:municipalityFilter', val)"
          append-to-body
          :calculate-position="withPopper"
          data-cy="municipality-filter"
        />
      </b-col>
      <base-date-time
        id="seproban_created_at_filter"
        :cols="6"
        :label="$t('date.created_at')"
        :value="createdAtFilter"
        mode="range"
        default-range-times
        date-format="Y-m-d H:i:S"
        @input="val => $emit('update:createdAtFilter', val)"
      />
      <base-date-time
        id="seproban_updated_at_filter"
        :cols="6"
        :label="$t('date.updated_at')"
        :value="updatedAtFilter"
        mode="range"
        default-range-times
        date-format="Y-m-d H:i:S"
        @input="val => $emit('update:updatedAtFilter', val)"
      />
      <base-date-time
        id="seproban_all_downloaded_at_filter"
        :cols="6"
        :label="$t('seproban.all_downloaded_at')"
        :value="allDownloadedAtFilter"
        mode="range"
        default-range-times
        date-format="Y-m-d H:i:S"
        @input="val => $emit('update:allDownloadedAtFilter', val)"
      />
      <base-date-time
        id="seproban_all_sent_at_filter"
        :cols="6"
        :label="$t('seproban.all_sent_at')"
        :value="allSentAtFilter"
        mode="range"
        default-range-times
        date-format="Y-m-d H:i:S"
        @input="val => $emit('update:allSentAtFilter', val)"
      />
    </b-row>
  </div>
</template>

<script>
import { BCard, BCardHeader, BCardBody, BRow, BCol, BButton } from "bootstrap-vue";
import vSelect from "vue-select";
import popperHelper from "@/libs/popper-helper";
import { BaseDateTime } from "@/components/Form";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BButton,
    vSelect,
    BaseDateTime,
  },
  props: {
    alarmOptions: {
      type: Array,
      default: null,
    },
    alarmFilter: {
      type: Array,
      default: null,
    },
    typeAlarmOptions: {
      type: Array,
      default: () => [],
    },
    typeAlarmFilter: {
      type: Array,
      default: null,
    },
    regionOptions: {
      type: Array,
      default: () => [],
    },
    regionFilter: {
      type: Array,
      default: null,
    },
    municipalityOptions: {
      type: Array,
      default: () => [],
    },
    municipalityFilter: {
      type: Array,
      default: null,
    },
    createdAtFilter: {
      type: String,
      default: "",
    },
    updatedAtFilter: {
      type: String,
      default: "",
    },
    allDownloadedAtFilter: {
      type: String,
      default: "",
    },
    allSentAtFilter: {
      type: String,
      default: "",
    },
  },
  setup() {
    return {
      withPopper: popperHelper.withPopper,
    };
  },
};
</script>
